import React, { useEffect, useState, useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import axios from '../helpers/axiosConfig';
import { toast } from 'react-toastify'; // Importation
import getBaseUrl from '../helpers/utility';

import { AuthContext } from '../helpers/AuthContext';


const DoublonsPersonnels = () => {
  const [doublons, setDoublons] = useState([]);
  const [message, setMessage] = useState('');
  const baseUrl = getBaseUrl();
  const [personnels, setPersonnels] = useState([]);
  const { authState } = useContext(AuthContext);
  let navigate = useNavigate();
  const location = useLocation(); // Utiliser useLocation pour accéder à l'emplacement

  const query = new URLSearchParams(location.search); // Utiliser location.search pour récupérer la chaîne de requête
  let token = localStorage.getItem('accessToken');
  const nomprenom = query.get('nomprenom');


  useEffect(() => {
    // Appel API pour récupérer les données de doublons

    fetchDoublons();
  }, []);

  const fetchDoublons = async () => {
    try {
      const response = await axios.get('/personnel/xxx/doublonspersonnels/dcca');
      const data = response.data;

      setDoublons(data.doublons);
      setMessage(data.message);
    } catch (error) {
      console.error('Erreur lors de la récupération des doublons:', error);
    }
  };


  const deletePersonnel = async (id) => {
    const confirmDeletion = async () => {
      await axios
        .delete(`personnel/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          toast.success(response.data.message);
          fetchDoublons(); // <<< 🔥 Actualisation immédiate
        })
        .then(() => setPersonnels(personnels.filter((personnel) => personnel.id !== id)))
        .catch((error) => toast.error(error.response.data.error));
    };

    const confirmToast = toast(
      <div>
        <p>Êtes-vous sûr de vouloir supprimer ce personnel ?</p>
        <button className="btn-info float-left " onClick={cancelDeletion}>
          Non
        </button>
        <button className="btn-danger float-right " onClick={confirmDeletion}>
          Oui
        </button>
      </div>,
      {
        autoClose: 3000,
        closeOnClick: false,
      }
    );
    function cancelDeletion() {
      toast.info('Suppression annulée.');
    }
  };


  return (
    <div className="container mt-3 ">
      <h2>Doublons des Personnels</h2>
      <div style={{ fontFamily: 'impact', fontSize: 40 }} className="text-danger">
        {message}
      </div>

      {doublons ? (
        <table className="table table-striped table-bordered table-sm">
          <thead className="thead-dark">
            <tr>
              <th>#</th>
              <th>Grade</th>
              <th>Nom et Prénom</th>
              <th>Fonction</th>
              <th>Matricule</th>
              <th>Position</th>
              <th>Compagnie</th>
              <th>Bataillon</th>
              <th>Brigade</th>
              <th>typePers</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {doublons.map((personnel) => (
              <tr key={personnel.id}>
                <td>{personnel.id}</td>
                <td>{personnel.grade?.name}</td>
                <td>{personnel.nomprenom}</td>
                <td>{personnel.fonction}</td>
                <td>{personnel.matricule}</td>
                <td>{personnel.positionexacte}</td>
                <td>{personnel.compagnie?.name}</td>
                <td>{personnel.compagnie?.bataillon?.name}</td>
                <td>{personnel.compagnie?.bataillon?.brigade?.name}</td>
                <td>{personnel.typePers}</td>
                <td>
                  {(authState.user.username === "Ira" ||
                    authState.user.username === "dcca" ||
                    authState.user.username === "colrodi") && (
                      <i
                        style={{ cursor: "pointer" }}
                        className="fa fa-trash fa-2x text-danger"
                        onClick={() => deletePersonnel(personnel.id)}
                      ></i>
                    )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div style={{ fontFamily: 'impact', fontSize: 40 }} className="text-danger">
          Il y a 0 groupe de doublon.
        </div>
      )}
    </div>
  );
};

export default DoublonsPersonnels;
